<template>
  <div>
    <div v-for="workflow in getWorkflows" :key="workflow.id">
      <div class="p-4 shadow-sm rounded-md bg-white dark:bg-slate-700">
        <div class="flex items-center justify-between ">
          <div class="  ">
            <div class="text-sm font-medium text-slate-700 dark:text-slate-50">
              <button
                  class="inline-flex text-sm font-medium rounded-md py-1 px-2 -ml-2 leading-6 text-slate-800 dark:text-slate-50 justify-between items-center hover:bg-slate-25 dark:hover:bg-slate-800"
                  :style="{ color: widgetColor }"
                  @click="triggerWorkflow(workflow.id)"
              >
            <span class="pr-2 text-sm">
              {{ workflow.name }}
            </span>
                <fluent-icon icon="arrow-right" size="14"/>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

import {mapGetters} from "vuex";
import FluentIcon from 'shared/components/FluentIcon/DashboardIcon';


export default {
  components:
      {
        FluentIcon
      },
  computed: {
    ...mapGetters({
      getWorkflows: 'workflows/getWorkflows', // Rename to avoid conflict
      widgetColor: 'appConfig/getWidgetColor',
    }),
  },
  methods: {
    triggerWorkflow(workflowId) {
      const {websiteToken} = window.chatwootWebChannel;
      this.$store.dispatch('workflows/trigger', {websiteToken, workflowId});
      //setTimeout(() => this.$emit('start-conversation'), 300);
        this.$emit('start-conversation');

    },
  },
  mounted() {
    const {websiteToken} = window.chatwootWebChannel;
    this.$store.dispatch('workflows/get', {
      websiteToken
    });
    this.$watch('getWorkflows', (newVal) => {
      console.log('Updated workflows:', newVal);
    });
  },


};
</script>

<style></style>



